export default __webpack_public_path__ + "static/media/mh.3263dfcc.svg";